(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-ordina"] && !Shopify.designMode) return;
  try {
    
(function() {
  // ── Hero slider
  var slider = document.getElementById('ord-hero-slider');
  if (slider) {
    var track = slider.querySelector('.ord-hero-slider__track');
    var slides = slider.querySelectorAll('.ord-hero-slider__slide');
    var dotsWrap = slider.querySelector('.ord-hero-slider__dots');
    var btnPrev = slider.querySelector('.ord-hero-slider__arrow--prev');
    var btnNext = slider.querySelector('.ord-hero-slider__arrow--next');
    var current = 0;
    var total = slides.length;

    if (total <= 1) {
      if (btnPrev) btnPrev.classList.add('ord-hidden');
      if (btnNext) btnNext.classList.add('ord-hidden');
    } else {
      // crea pallini
      var dots = [];
      for (var i = 0; i < total; i++) {
        var d = document.createElement('button');
        d.className = 'ord-hero-slider__dot' + (i === 0 ? ' ord-active' : '');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function(idx) { d.addEventListener('click', function() { goTo(idx); }); })(i);
        dotsWrap.appendChild(d);
        dots.push(d);
      }

      function goTo(n) {
        current = (n + total) % total;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function(d, i) {
          d.classList.toggle('ord-active', i === current);
        });
      }

      btnPrev.addEventListener('click', function() { goTo(current - 1); });
      btnNext.addEventListener('click', function() { goTo(current + 1); });

      // touch swipe
      var touchStartX = 0;
      track.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { goTo(current + (diff > 0 ? 1 : -1)); }
      }, { passive: true });

    }
  }

  // ── Countdown timer (5 minuti, si resetta)
  var MINUTES = 5;
  var key = 'ord_cd_end';
  var end = parseInt(sessionStorage.getItem(key));
  if (!end || end < Date.now()) {
    end = Date.now() + MINUTES * 60 * 1000;
    sessionStorage.setItem(key, end);
  }
  function updateCD() {
    var diff = Math.max(0, end - Date.now());
    var m = Math.floor(diff / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var mm = document.getElementById('ord-cd-min');
    var ss = document.getElementById('ord-cd-sec');
    if (mm) mm.textContent = (m < 10 ? '0' : '') + m;
    if (ss) ss.textContent = (s < 10 ? '0' : '') + s;
    if (diff <= 0) {
      end = Date.now() + MINUTES * 60 * 1000;
      sessionStorage.setItem(key, end);
    }
  }
  updateCD();
  setInterval(updateCD, 1000);

  // ── Ripristina pulsanti se l'utente torna indietro dal checkout
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      document.querySelectorAll('.ord-card__btn').forEach(function(btn) {
        btn.disabled = false;
        btn.textContent = 'Ordina Ora';
      });
    }
  });

  // ── Add to cart on card button click
  document.querySelectorAll('.ord-card__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      this.disabled = true;
      this.textContent = 'Elaborazione...';
      var self = this;
      fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() { window.location.href = '/checkout'; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
